import { DocumentNode, gql } from "@apollo/client";

class SignUpService {
  public static signUpByPassword = (): DocumentNode => gql`
    mutation SignUpByPassword($signUpByPasswordData: SignUpByPasswordDTO!) {
      signUpByPassword(signUpByPasswordData: $signUpByPasswordData) {
        isTokenValid
        user {
          id
          email
        }
      }
    }
  `;

  public static sendActivationCode = (): DocumentNode => gql`
    mutation sendActivationCode($sendActivationCodeData: SignUpDTO!) {
      sendActivationCode(sendActivationCodeData: $sendActivationCodeData)
    }
  `;

  public static verifyEmailCode = (): DocumentNode => gql`
    mutation VerifyEmailCode($verifyEmailCodeData: VerifyEmailCodeDTO!) {
      verifyEmailCode(verifyEmailCodeData: $verifyEmailCodeData) {
        success
        message
      }
    }
  `;
}

export default SignUpService;
